import React from 'react';
import RaceVideoPlayer from 'modules/HorseRacing/components/RaceVideoPlayer';
import moment from 'moment';

export default function HorseRacingLastRun({lastRun}) {
    if (!lastRun) {
        return null;
    }

    const lastRunMoment = moment(`${lastRun.date} ${lastRun.time}`, 'YYYY-MM-DD HH:mm:ss');

    return (
        <div className="hr-racing-runner-form-watch-last-run">
            <h4><span className="bold">Last Run</span> : {lastRun.race_name} {lastRunMoment ? lastRunMoment.format('HH:mm DD/MM/YYYY'): null}</h4>
            {lastRun.ride_description ? <p>{lastRun.ride_description}</p> : null}
            {lastRun.video && <RaceVideoPlayer videos={[lastRun.video]}/>}
        </div>
    );
}


// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingLastRun.js